export const HOTEL_SEARCH_DESTINATION_TYPE = 'htl_dest_type';
export const HOTEL_SEARCH_DESTINATION_ID = 'htl_dest_id';
export const HOTEL_SEARCH_DESTINATION_IATA = 'htl_dest_iata';
export const HISTORY_DATA = 'history_data';
